import Validation from '../../../data/validation/validation'
import { StringValidationRule, PhoneValidationRule } from '../../../data/validation/rules'
import { ScrollIntoViewById } from '../../../utils/UIHelper'
import Requests from "../../../utils/Requests"

const getDefaultState = () => {
    return {
        processing: false,
        title: "",
        firstname: "",
        middlename: "",
        lastname: "",
        phone: "",
        enrollmentNumber: "",
        password: "",
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const IsValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.firstname, (error) => instance.state.errors.firstname = error, { min: { value: 2, error: "Invalid" }, max: { value: 25, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.middlename, (error) => instance.state.errors.middlename = error, { min: { value: 0, error: "Invalid" }, max: { value: 25, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.lastname, (error) => instance.state.errors.lastname = error, { min: { value: 2, error: "Invalid" }, max: { value: 25, error: "Invalid" } })
    validation.addValidationRule(PhoneValidationRule, instance.state.phone, (error) => instance.state.errors.phone = error, { allowNull: false })
    validation.addValidationRule(StringValidationRule, instance.state.enrollmentNumber, (error) => instance.state.errors.enrollmentNumber = error, { min: { value: 5, error: "Invalid" }, max: { value: 30, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.password, (error) => instance.state.errors.password = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Invalid" } })

    instance.setState({
        ...instance.state,
        errors: errors
    }, () => {
        for (let error in instance.state.errors) {
            if (instance.state.errors[error].length > 0) {
                ScrollIntoViewById(error)
                return
            }
        }
    })
    return validation.validate()
}

const register = instance => {

    if (instance.state.updating) {
        return
    }

    instance.setState({
        ...instance.state,
        processing: true
    })

    let data = {
        firstname: instance.state.firstname,
        middlename: instance.state.middlename,
        lastname: instance.state.lastname,
        phone: instance.state.phone,
        enrollmentNumber: instance.state.enrollmentNumber,
        password: instance.state.password,
        showInPublicDirectory: true,
        token: instance.props.match.params.token
    }

    Requests(instance.props)
        .withPost()
        .withData(data)
        .withUrl('/api/member/create')
        .then(response => handleRegisterResponse(instance, response), error => handleError(instance, error))
}

const handleRegisterResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.props.history.push('/auth/register/success')
            break;
        default:
            instance.setState({
                ...instance.state,
                processing: false,
                flag: {
                    type: "error",
                    text: response.message
                }
            })
    }
}

export const handleError = (instance, error) => {
    instance.setState({
        ...instance.state,
        processing: false,
        flag: {
            type: "",
            text: ""
        }
    })

    alert(error)
    
}

const Service = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => IsValid(instance),
        register: () => register(instance)
    }
}

export default Service